var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08866 3.66897C7.45812 3.25846 7.42484 2.62617 7.01433 2.25671C6.60382 1.88726 5.97153 1.92053 5.60207 2.33104L1.60207 6.77549L1 7.44445L1.60207 8.11342L5.60207 12.5579C5.97153 12.9684 6.60382 13.0017 7.01433 12.6322C7.42484 12.2627 7.45812 11.6304 7.08866 11.2199L4.59072 8.44445H17.3454C19.0022 8.44445 20.3454 9.7876 20.3454 11.4444V16.7778C20.3454 18.4346 19.0022 19.7778 17.3454 19.7778H8.91679C8.36451 19.7778 7.91679 20.2255 7.91679 20.7778C7.91679 21.3301 8.36451 21.7778 8.91679 21.7778H17.3454C20.1068 21.7778 22.3454 19.5392 22.3454 16.7778V11.4444C22.3454 8.68302 20.1068 6.44445 17.3454 6.44445H4.59073L7.08866 3.66897Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.abdc1b5746746eaa53ac0c3f9ff4fd22.svg";
export { ForwardRef as ReactComponent };